module.exports = "/img/1.0b01be.jpg";